var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSlotVisible())?_c('div',[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }